import { useState, useEffect } from 'react';
import get from 'lodash/get';
import { defaultColorSettings } from '@drs/viewer-config';
import files from '@framework/url/filesUrl';
import { useRoadshowContext } from '@drs/roadshow-context';
import { AlertManager } from '@dealroadshow/uikit-alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import RoadshowRepository from '@drs/infrastructure/repository/RoadshowRepository';
import { getContainer } from '@framework/di/getContainer';

const useCustomization = () => {
  const container = getContainer();
  const { roadshow } = useRoadshowContext();

  const [viewerColorSettings, setViewerColorSettings] = useState<{ [key:string]: any }>(defaultColorSettings);
  const [customButtonEnabled, setCustomButtonEnabled] = useState(false);
  const [viewerCustomizationEnabled, setViewerCustomizationEnabled] = useState(false);
  const [isCustomizationDisclaimerEnabled, setCustomizationDisclaimerEnabled] = useState(false);
  const [isPending, setPending] = useState(true);

  useEffect(() => {
    if (roadshow.createTopButton) {
      setCustomButtonEnabled(roadshow.createTopButton);
      setViewerColorSettings({
        ...roadshow.createTopButtonSettings,
      });
    }
    if (roadshow.viewerCustomizationEnabled) {
      setViewerCustomizationEnabled(roadshow.viewerCustomizationEnabled);
    }
    if (roadshow?.viewerDisclaimerCustomizationEnabled) {
      setCustomizationDisclaimerEnabled(
        roadshow?.viewerDisclaimerCustomizationEnabled,
      );
    }
    if (roadshow.viewerCustomizationEnabled || roadshow?.viewerDisclaimerCustomizationEnabled) {
      setViewerColorSettings({
        ...roadshow.viewerCustomSettings,
        ...roadshow.createTopButtonSettings,
        viewerDisclaimerSettings: roadshow.viewerDisclaimerSettings,
      });
    }
  }, [roadshow]);

  const getCustomLogo = (): (string | null) => {
    if (!get(viewerColorSettings, 'viewerDisclaimerSettings.disclaimerLogo')) return null;
    return files.getFileUrl(viewerColorSettings.viewerDisclaimerSettings.disclaimerLogo.url);
  };

  const getViewerCustomSettings = async (entryCode: string): Promise<void> => {
    try {
      const roadshowRepository = container.get(RoadshowRepository);
      const response = await roadshowRepository.getViewerCustomSettings({ entryCode });
      setViewerColorSettings(response);
      if (response) {
        setViewerCustomizationEnabled(true);
        setCustomizationDisclaimerEnabled(!!response.viewerDisclaimerCustomizationEnabled);
      }
      setPending(false);
    } catch (e) {
      AlertManager.error(getErrorMessage(e));
    }
  };

  return {
    setViewerColorSettings,
    setCustomButtonEnabled,
    setViewerCustomizationEnabled,
    colorSettings: viewerColorSettings,
    isCustomButtonEnabled: customButtonEnabled,
    isCustomPresentation: viewerCustomizationEnabled,
    isCustomizationDisclaimerEnabled,
    getCustomLogo,
    getViewerCustomSettings,
    isPending,
  };
};

export default useCustomization;
